export default {
  statsTitle: "Statistiques",
  statsSub: "Statistiques",
  riderRankTitle: "Classement livreurs",
  riderRankSub: "Classement",
  storeDispatchTitle: "Envois marchands",
  storeDispatchSub: "Envois",
  incomeShareTitle: "Part du chiffre",
  incomeShareSub: "Répartition",
  chartOrderCount: "Commandes",
  chartIncome: "Chiffre",
};
